import React from 'react'
import {
  LoginSplash,
  LoginSplashForm,
  LoginSplashButton
} from './home.css'
import storeIcon from '../public/backStage.jpg'

export default class LogInSplashScreen extends React.Component {

  componentDidMount() {
    document.title = "Off Price Workspace Sign In"
  }

  render() {
    return (
      <div className={LoginSplash}>
        <div className={LoginSplashForm}>
          <div>
            <h3><img src={storeIcon}/></h3>
          </div>
          <h1>BackStage Workspace</h1>
          <a type="button" href="/login" className={LoginSplashButton}>Sign in</a>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./components/LogInSplashScreen.js